<div class="sme-global-toolbar border-bottom bg-light px-3 py-2 d-flex justify-content-between align-items-center">
  <button type="button" class="btn btn-outline-secondary btn-sm" (click)="goBack()">← Back</button>
  <div class="d-flex align-items-center gap-2">
    <a routerLink="/SME/help" class="btn btn-outline-primary btn-sm">Help</a>
    <span class="small text-muted">SME workspace</span>
  </div>
  <button type="button" class="btn btn-outline-danger btn-sm" (click)="requestLogout()">Logout</button>
</div>

<router-outlet></router-outlet>
